<template>
  <div>
    <small class="text-secondary">
      <a href="#">Phantomea</a> <small>{{date}}</small>
    </small>
  </div>
</template>

<script>
export default {
  name: "Creator",
  props: {
    date: {
      type: String
    }
  }
}
</script>